<style lang="scss">
  .bookSubContent {
    h1 {
      margin: 0;
      font-size: 34px;
      font-weight: 800;
      text-transform: uppercase;
    }
    h2 {
      margin: 0 0 30px 0;
      font-size: 16px;
      font-weight: 600;
    }
    p {
      line-height: 24px;
      font-size: 14px;
    }
    hr {
      margin: 70px 0;
    }
    .smallData {
      margin: 70px 0 0 0;
      line-height: 30px;
      span {
        font-size: 16px;
        font-weight: 800;
        color: #B9DD64;
        strong {
          font-weight: 800;
        }
      }
      strong {
        display: inline-block;
        vertical-align: baseline;
        width: 160px;
        font-size: 16px;
      }
    }
    .olvassBele {
      position: relative;
      max-width: 100%;
      overflow: hidden;
      align-self: center;
      h2 {
        position: relative;
        z-index: 1;
        margin: 20px 0 35px 0;
        text-align: left;
        font-size: 18px;
        font-weight: 600;
      }
      .titleBg {
        position: absolute;
        top: -10px;
        left: 40px;
        z-index: 0;
        line-height: 108px;
        font-size: 108px;
        font-weight: 600;
        color: #F2F2F2;
        display: none;
      }
      .btn {
        position: relative;
        z-index: 3;
        text-transform: uppercase;
        width: 100%;
      }
    }
    .btnShare {
      display: block;
      position: relative;
      width: 100%;
      margin: 15px 0;
      color: #fff;
      text-transform: uppercase;
      &:last-child {
        margin-bottom: 0;
      }
      .fab {
        position: absolute;
        top: 9px;
        left: 15px;
        font-size: 30px;
      }
      &.bsFacebook {
        background-color: #3B5998;
      }
      &.bsPinterest {
        background-color: #CB2027;
      }
      &.bsTwitter {
        background-color: #1da1f2;
      }
    }
    .bigData {
      .bdImg {
        margin-bottom: 30px;
        .bookCover {
          -webkit-box-shadow: 0 0 30px 0 rgba(0,0,0,.3);
          box-shadow: 0 0 30px 0 rgba(0,0,0,.3);
        }
      }
      .bdTxt {
        p {
          text-align: justify;
        }
      }
      h2 {
        margin: 20px 0;
      }
      p {
        margin-bottom: 40px;
      }
      > p {
        height: 75px;
        overflow: hidden;
      }
      .panels {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-self: stretch;
        > div {
          position: relative;
          padding: 120px 30px 140px 30px;
          text-align: center;
          .bookProgress {
            top: -24px;
            left: 50%;
            width: 120px;
            margin: 0 0 0 -60px;
          }
          p {
            font-size: 12px;
            strong {
              text-transform: uppercase;
              font-weight: 800;
            }
          }
          .priceBtn {
            position: absolute;
            right: 20px;
            bottom: 20px;
            left: 20px;
            .price {
              margin: 0 0 15px 0;
              font-size: 20px;
              font-weight: 800;
              small {
                display: block;
                margin-bottom: 20px;
                font-size: 12px;
                font-weight: 600;
                color: #4F4F58;
                text-decoration: line-through;
              }
            }
            .btn {
              width: 100%;
              max-width: 260px;
              text-transform: uppercase;
            }
          }
          &.pCart {
            z-index: 2;
            -webkit-box-shadow: 0 0 20px 0 rgba(0,0,0,.1);
            box-shadow: 0 0 20px 0 rgba(0,0,0,.1);
          }
          &.pWebshop {
            background-color: #fafafa;
            .bookProgress {
              > div {
                background-image: url('/static/images/icons/booksub-webshop.svg');
                background-repeat: no-repeat;
                background-size: 30px 60px;
                background-position: center;
              }
            }
          }
        }
      }
    }
    .sideNote {
      white-space: pre-wrap;
      h2 {
        margin: 0;
      }
      p {
        height: 286px;
        overflow: hidden;
        margin-bottom: 0;
        text-align: justify;
        &.open {
          height: auto;
        }
      }
      .readMoreBtn {
        display: block;
        margin: -20px 0 0 0;
        cursor: pointer;
        font-size: 14px;
        color: #B9DD64;
      }
      @media (max-width: 768px) {
        .readMoreBtn {
          margin-bottom: 40px;
        }
      }
      @media (min-width: 768px) {
        p {
          height: 125px;
        }
      }
      @media (min-width: 992px) {
        p {
          height: 190px;
        }
      }
      @media (min-width: 1270px) {
        p {
          height: 318px;
          margin-bottom: 6px;
        }
      }
    }
    .bloggers {
      a {
        display: grid;
        grid-template-columns: 90px 1fr;
        grid-gap: 20px;
        align-items: center;
        position: relative;
        min-height: 130px;
        margin: 0 0 30px 0;
        padding: 20px;
        line-height: 26px;
        font-size: 14px;
        color: #232323;
        background-color: #FAFBFC;
        -webkit-box-shadow: 0 0 20px 0 rgba(0,0,0,.1);
        box-shadow: 0 0 20px 0 rgba(0,0,0,.1);
        &:hover {
          text-decoration: none;
        }
        img {
          width: 90px;
          height: 90px;
          border-radius: 45px;
        }
        strong {
          display: block;
          font-size: 16px;
        }
      }
    }
    #pdfModal {
      .modal-body {
        height: 600px;
        iframe {
          width: 100%;
          height: 100%;
        }
      }
    }
    .others {
      .books {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 50px;
        grid-row-gap: 80px;
        p:nth-of-type(2) {
          font-size: 16px;
        }
      }
    }
    .author {
      .authorHeader {
        margin: 80px 0 20px 0;
        img {
          display: inline-block;
          margin-bottom: 20px;
          width: 140px;
          height: 140px;
          border-radius: 70px;
        }
        p {
          margin-bottom: 30px;
          font-weight: 600;
        }
      }
      p {
        margin-bottom: 0;
        text-align: justify;
        white-space: pre-wrap;
      }
    }
    @media (min-width: 567px) {
      .author {
        .authorHeader {
          position: relative;
          padding: 0 0 0 170px;
          img {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
      .bigData {
        .panels > div {
          p, p strong {
            font-size: 16px;
          }
          .priceBtn {
            right: 40px;
            left: 40px;
            .price {
              font-size: 34px;
              small {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
    @media (min-width: 768px) {
      .bigData {
        display: grid;
        grid-template-columns: 1fr 2fr;
        grid-gap: 30px;
        grid-template-areas:
          'img   txt'
          'panels panels';
        .bdImg { grid-area: img; }
        .bdTxt { grid-area: txt; }
        .panels { grid-area: panels; }
      }
      .bscGrid:not(.bscGridLg) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 30px;
      }
    }
    @media (min-width: 992px) {
      .olvassBele .titleBg {
        display: block;
      }
      .others .books, {
        grid-template-columns: repeat(4, 1fr);
      }
      .bscGrid.bscGridLg {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 30px;
      }
      .author .authorHeader {
        margin-top: 0;
      }
    }
    @media (min-width: 1270px) {
      .bigData {
        grid-template-columns: 2fr 3fr;
        grid-template-areas:
          'img txt'
          'img panels';
        grid-template-rows: 200px 1fr;
        grid-column-gap: 70px;
        .bdImg {
          margin-bottom: 0;
        }
        .bdTxt {
          p {
            height: 72px;
            overflow: hidden;
            margin: 0;
          }
        }
        .panels {
          > div {
            min-height: 325px;
            padding-bottom: 90px;
          }
        }
      }
      .bscGrid:not(.bscGridLg),
      .bscGrid.bscGridLg {
        grid-template-columns: 2fr 3fr;
        grid-column-gap: 70px;
      }
      .olvassBele .btn {
        width: 260px;
      }
    }
  }
</style>
<template>
  <div class="bookSubContent">
    <FrontendNav></FrontendNav>
    <div class="container">
      <div class="bigData">
        <div class="bdImg">
          <img v-bind:src="thisBookData.imgUrl_url" v-bind:alt="thisBookData.title" class="bookCover">
        </div>
        <div class="bdTxt">
          <h1>{{thisBookData.title}}</h1>
          <h2>{{thisBookData.title_line}}</h2>
          <p>{{thisBookData.description}}</p>
        </div>
        <div class="panels">
          <div class="pCart">
            <div class="bookProgress">
              <div>{{thisBookData.available_quantity}}/1000</div>
              <ProgressCircle :perc="((1000-thisBookData.available_quantity)/1000*100).toString()"></ProgressCircle>
            </div>
            <p><strong>{{booksubCart}}</strong></p>
            <div class="priceBtn">
              <p class="price">
                <small>{{thisBookData.externalPrice}} Ft</small>
                {{thisBookData.price}} Ft
              </p>
              <button class="btn btn-primary" v-on:click="addToCart">Kosárba</button>
            </div>
          </div>
          <div class="pWebshop">
            <div class="bookProgress bpNoanim">
              <div></div>
              <ProgressCircle :perc="'100'"></ProgressCircle>
            </div>
            <p>{{booksubWebshop}}</p>
            <div class="priceBtn">
              <p class="price">{{thisBookData.externalPrice}} Ft</p>
              <a :href="thisBookData.externalLink" target="_blank" class="btn btn-outline">Webshop</a>
            </div>
          </div>
        </div>
      </div>
      <div class="bscGrid">
        <div>
          <p class="smallData">
            <span><strong>Szerző:</strong> {{thisBookData.author}}</span><br>
            <strong>Kiadó:</strong> {{thisBookData.publisher}}<br>
            <strong>Oldalak száma:</strong> {{thisBookData.pageNumber}}<br>
            <strong>Borító:</strong> {{thisBookData.cover}}<br>
            <strong>ISBN:</strong> {{thisBookData.isbn}}<br>
            <strong>Nyelv:</strong> {{thisBookData.language}}<br>
            <strong>Kiadás éve:</strong> {{thisBookData.publish_date}}<br>
            <strong>Árukód:</strong> {{thisBookData.sku}}<br>
          </p>
        </div>
        <div class="olvassBele">
          <h2>Olvass bele</h2>
          <span class="titleBg">Olvass bele</span>
          <button class="btn btn-outline" data-toggle="modal" data-target="#pdfModal">Megnézem</button>
          <div class="modal fade" id="pdfModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <iframe v-bind:src="thisBookData.pdfUrl_url" frameborder="0"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="bscGrid">
        <div>
          <p><strong>Oszd meg ismerőseiddel ezt a lehetőséget és előbb hozzájuthatsz Te is a könyvedhez!</strong></p>
          <a v-bind:href="social.facebook" target="_blank" class="btn btnShare bsFacebook"><i class="fab fa-facebook-f"></i>Megosztás</a>
          <a v-bind:href="social.pinterest" target="_blank" class="btn btnShare bsPinterest"><i class="fab fa-pinterest-p"></i>Megosztás</a>
          <a v-bind:href="social.twitter" target="_blank" class="btn btnShare bsTwitter"><i class="fab fa-twitter"></i>Megosztás</a>
        </div>
        <div>
          <div class="fb-comments" :data-href="currentUrl" data-width="100%" data-numposts="5"></div>
        </div>
      </div>
      <hr>
      <div class="bscGrid">
        <div class="sideNote">
          <template v-if="thisBookData.sidenote">
            <h2>{{thisBookData.sidenote_title}}</h2>
            <p v-bind:class="{open: sideNoteOpen}">{{thisBookData.sidenote}}</p>
            <span class="readMoreBtn" @click="readMore">olvass tovább</span>
          </template>
        </div>
        <div>
          <div class="embed-responsive embed-responsive-16by9">
            <div v-html="thisBookData.youtubeUrl"></div>
          </div>
        </div>
      </div>
      <hr>
      <div class="bscGrid bscGridLg">
        <div class="bloggers">
          <a v-if="thisBookData.blogger1_name" v-bind:href="thisBookData.blogger1_link">
            <img v-bind:src="thisBookData.blogger1_img_url" v-bind:alt="thisBookData.blogger1_name">
            <div>
              <strong>{{thisBookData.blogger1_name}}</strong>
              "{{thisBookData.blogger1_text}}"
            </div>
          </a>
          <a v-if="thisBookData.blogger2_name" v-bind:href="thisBookData.blogger2_link">
            <img v-bind:src="thisBookData.blogger2_img_url" v-bind:alt="thisBookData.blogger2_name">
            <div>
              <strong>{{thisBookData.blogger2_name}}</strong>
              "{{thisBookData.blogger2_text}}"
            </div>
          </a>
          <a v-if="thisBookData.blogger3_name" v-bind:href="thisBookData.blogger3_link">
            <img v-bind:src="thisBookData.blogger3_img_url" v-bind:alt="thisBookData.blogger3_name">
            <div>
              <strong>{{thisBookData.blogger3_name}}</strong>
              "{{thisBookData.blogger3_text}}"
            </div>
          </a>
        </div>
        <div class="author">
          <template v-if="thisBookData && thisBookData.authorData">
          <div class="authorHeader">
            <img v-bind:src="thisBookData.authorData.image_url" alt="">
            <h2>{{thisBookData.author}}</h2>
            <p>{{thisBookData.authorData.lead}}</p>
          </div>
          <p>{{authorTxt}}</p>
          </template>
        </div>
      </div>
      <hr>
      <div v-if="otherBooks" class="others">
        <h2>Más művek a szerzőtől</h2>
        <ul class="books">
          <li v-for="book in otherBooks" :key="book.id">
            <FrontendBooklink
              :button="false"
              :book="book"
            ></FrontendBooklink>
          </li>
        </ul>
      </div>
    </div>
    <div class="bookSubToaster">
      <FrontendToaster
        :text="'A könyvet sikeresen a kosarába tettük.'"
        :delay="4000"
        ></FrontendToaster>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'
import ProgressCircle from '../partials/progress-circle'
import FrontendBooklink from '../partials/booklink'
import FrontendToaster from '../partials/toaster'

export default {
  name: 'FrontendBookSub',
  components: {
    FrontendNav,
    FrontendFooter,
    ProgressCircle,
    FrontendBooklink,
    FrontendToaster
  },
  created: function () {
    let url = process.env.API_URL + '/' + process.env.API_ENDPOINT
    this.$http
      .get(url + `/book/${this.$route.params.slug}`, {
        'headers': {
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.thisBookData = res.data.data
        this.$http
          .get(url + `/book-by-author/` + this.thisBookData.id + `/` + this.thisBookData.author_id, {
            'headers': {
              'language': this.$store.state.loading.language
            }
          }).then(res => {
            this.otherBooks = res.data.data
          }).catch(res => {
          })
      }).catch(res => {
        this.$router.push('/konyvek')
      })
    this.cartItems = JSON.parse(localStorage.getItem('cartItems'))
  },
  data: function () {
    return {
      thisBookData: {},
      otherBooks: [],
      newCartItem: true,
      cartItems: [],
      social: {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href,
        pinterest: 'https://pinterest.com/pin/create/button/?url=' + window.location.href + '&media=&description=',
        twitter: 'https://twitter.com/home?status=' + window.location.href
      },
      sideNoteOpen: false,
      currentUrl: window.location.href
    }
  },
  methods: {
    readMore: function () {
      this.sideNoteOpen = !this.sideNoteOpen
    },
    addToCart: function () {
      if (this.cartItems) {
        for (let i = 0; i < this.cartItems.length; i++) {
          if (this.cartItems[i].title === this.thisBookData.title) {
            this.newCartItem = false
          }
        }
        if (this.newCartItem) {
          this.cartItems.push(this.thisBookData)
          this.saveBooks()
        }
      } else {
        this.cartItems = []
        this.cartItems.push(this.thisBookData)
        this.saveBooks()
      }
    },
    saveBooks: function () {
      window.$('.bookSubToaster .toast').toast('show')
      this.$store.commit('loading/setCartNum', this.cartItems.length)
      localStorage.setItem('cartItems', JSON.stringify(this.cartItems))
    }
  },
  mounted: function () {
    window.$('.bookSubToaster .toast').on('shown.bs.toast', function () {
      window.$('.bookSubToaster .toastWr').addClass('show')
    })
    window.$('.bookSubToaster .toast').on('hidden.bs.toast', function () {
      window.$('.bookSubToaster .toastWr').removeClass('show')
    })
  },
  computed: {
    authorTxt: function () {
      return '"' + this.thisBookData.authorData.description + '"'
    },
    booksubCart: function () {
      return this.$store.state.loading.txtContent.booksubCart
    },
    booksubWebshop: function () {
      return this.$store.state.loading.txtContent.booksubWebshop
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/booksub/booksub.vue